import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { FieldArrayType, FieldType, FormlyFieldConfig } from '@ngx-formly/core';

import { FieldConfig } from '../../helpers/field.config';
import { StudioIntegrationService } from "../../services/studio-integration/studio-integration.service";
import { ActivatedRoute } from '@angular/router';

export class MyCustomFieldArrayType extends FieldArrayType<FieldConfig>{
  data: {};
  atLeastOneRowSel: boolean;
}

@Component({
  selector: "app-accordion-type",
  templateUrl: "./column-accordion-type.component.html",
  styleUrls: ["./column-accordion-type.component.scss"],
})
export class ColumnAccordionTypeComponent
  extends MyCustomFieldArrayType
  implements OnInit
{
  fieldConfig: FieldConfig;
  selectAllTablesRows: boolean;
  isTemplate: boolean = false;
  constructor(private studioIntegrationService: StudioIntegrationService,  private route: ActivatedRoute) {
    super();
    this.studioIntegrationService.currentSelectAllTablesRows.subscribe(
      (val) => (this.selectAllTablesRows = val)
    );

  }

  ngOnInit() {
    if(this.route.data['_value']['mode'] === 'attach' || this.route.data['_value']['type'] === 'edit-attach'){
      this.isTemplate = true;
    }
    this.fieldConfig = this.field;
    this.field.data = this.field.data || {};
    this.field.atLeastOneRowSel = false;
    this.selectAllTablesRows = false;
  }
  defaultOptions = {
    defaultValue: {},
  };

  /**
   * Callback to invoke when an active tab is collapsed by clicking on the header.
   * @param $event Tabview event
   */
  onClose(event) {
    if (this.to.onClose) {
      this.to.onClose(event);
    }
  }

  /**
   * Callback to invoke when a tab gets expanded.
   * @param $event Tabview event
   */
  onOpen(event) {
    if (this.to.onOpen) {
      this.to.onOpen(event);
    }
  }

  onSelectAllColumsInAllRows(event) {
    this.studioIntegrationService.callFunOfSelectRowsofAllTables();
  }
}
